{
  "startTaxLossHarvesting": "Iniciar una nueva compensación de pérdidas fiscales",
  "youDontHavePermission": "No tiene permiso para ejecutar el trabajo TLH",
  "newTLHJobRun": "Nuevo trabajo de compensación de pérdidas fiscales",
  "newTLHJobStarted": "El trabajo de análisis de compensación de pérdidas fiscales se está ejecutando ahora en segundo plano.",
  "newTLHJobFailed": "El trabajo de análisis de compensación de pérdidas fiscales no se ha podido iniciar. Inténtelo de nuevo más tarde.",
  "analysisOn": "análisis en",
  "state": "Estado",
  "organization": "Organización",
  "table": {
    "ranAt": "se ejecutó en",
    "numEvents": "número de eventos (operaciones)",
    "state": "estado",
    "organization": "organización",
    "user": "Usuario",
    "account": "Cuenta",
    "symbol": "Símbolo",
    "substituteSymbol": "Símbolo sustituto",
    "costBase": "Base de costos",
    "adjustedCostBase": "Base de costos ajustados",
    "price": "Precio",
    "sellQuantity": "Cantidad",
    "expectedSellValue": "Valor de venta esperado",
    "assetValueAsOf": "Valor de este activo a fecha de",
    "gainLossPercentage": "Ganancia (pérdida) %",
    "gainLossValue": "Ganancia (pérdida) $",
    "bookValue": "Valor contable"
  },
  "errors": {
    "noSuchTLHJob": "No existe tal trabajo de compensación de pérdidas fiscales"
  }
}
